<template>
  <div class="wrapper">
    <h1 style="text-align: center">收支明细表</h1>
    <div class="table-title">
      <p>项目名称：{{ detail.projectName ? detail.projectName : "" }}</p>
      <p>{{ detail.createTime ? detail.createTime : "" }}</p>
      <p>单位：元</p>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :span-method="spanArrayMethod"
        height="500"
      >
        <el-table-column
          label="序号"
          prop="myindex"
          width="50"
        ></el-table-column>
        <el-table-column label="工程明细情况">
          <el-table-column label="项目名称" prop="title1"></el-table-column>
          <el-table-column
            :label="detail.projectName ? detail.projectName : ''"
            prop="title2"
          ></el-table-column>
        </el-table-column>
        <el-table-column label="合同金额">
          <template slot-scope="scope">
            <div>{{ formatDisplayNumber(scope.row, "contractAmount") }}</div>
          </template>
        </el-table-column>
        <el-table-column label="预算金额">
          <el-table-column label="含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "budgetTaxAmount") }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额">
            <template slot-scope="scope">
              <div>
                {{ formatDisplayNumber(scope.row, "budgetNoTaxAmount") }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="实际发生金额">
          <el-table-column label="含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "actTaxAmount") }}</div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额">
            <template slot-scope="scope">
              <div>{{ formatDisplayNumber(scope.row, "actNoTaxAmount") }}</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <div class="table-footer">
        <p>项目经理：</p>
        <p style="margin-right: 100px">制表人：</p>
      </div>
    </div>
    <div class="page-bottom-control">
      <el-button v-if="approveStatus && approveStatus != 2" type="primary" @click="previewHandler">打印</el-button>
      <el-button type="primary" @click="exportData">导出</el-button>
      <el-button type="info" @click="closePage">关闭</el-button>
    </div>

    <el-dialog
      title="预览"
      :visible="dialogVisible"
      width="80%"
      @close="dialogClosed"
    >
      <div id="earningCostDetailTablePrint">
        <h1 style="text-align: center">收支明细表</h1>
        <div>
          <p>项目名称：{{ detail.projectName ? detail.projectName : "" }}</p>
          <p>{{ detail.createTime ? detail.createTime : "" }}</p>
          <p>单位：元</p>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border: 1px solid black;
              table-layout: fixed;
              border-collapse: collapse;
            "
          >
            <thead>
              <tr style="text-align: left; border-bottom: 1px solid black">
                <th
                  style="
                    border-right: 1px solid black;
                    box-sizing: border-box;
                    width: 100px;
                  "
                  rowspan="2"
                >
                  <div style="padding: 12px 4px">序号</div>
                </th>
                <th
                  style="border-right: 1px solid black"
                  colspan="2"
                  rowspan="1"
                >
                  <div style="padding: 12px 4px">工程明细情况</div>
                </th>
                <th style="border-right: 1px solid black" rowspan="2">
                  <div style="padding: 12px 4px">合同金额</div>
                </th>
                <th
                  style="border-right: 1px solid black"
                  rowspan="1"
                  colspan="2"
                >
                  <div style="padding: 12px 4px">预算金额</div>
                </th>
                <th
                  style="border-right: 1px solid black"
                  rowspan="1"
                  colspan="2"
                >
                  <div style="padding: 12px 4px">实际发生金额</div>
                </th>
                <th style="border-right: 1px solid black" rowspan="2">
                  <div style="padding: 12px 4px">备注</div>
                </th>
              </tr>
              <tr style="text-align: left; border-bottom: 1px solid black">
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">项目名称</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">{{ detail.projectName }}</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">含税金额</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">不含税金额</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">含税金额</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">不含税金额</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>1</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>工程进展</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ detail.projectProcess }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
              <!-- 2 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>2</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectAmount
                          ? detail.projectAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectAmount
                          ? detail.projectAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectAmount
                          ? detail.projectAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectAmount
                          ? detail.projectAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.projectAmount ? detail.projectAmount.remark : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 3 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>3</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>暂定金（变更金额）</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.provisionalAmount
                          ? detail.provisionalAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.provisionalAmount
                          ? detail.provisionalAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.provisionalAmount
                          ? detail.provisionalAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.provisionalAmount
                          ? detail.provisionalAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.provisionalAmount
                        ? detail.provisionalAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 4 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>4</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>清单复核金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.listCheckAmount
                          ? detail.listCheckAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.listCheckAmount
                          ? detail.listCheckAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.listCheckAmount
                          ? detail.listCheckAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.listCheckAmount
                          ? detail.listCheckAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.listCheckAmount
                        ? detail.listCheckAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 5 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>5</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同物价指数金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractPriceIndexAmount
                          ? detail.contractPriceIndexAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractPriceIndexAmount
                          ? detail.contractPriceIndexAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractPriceIndexAmount
                          ? detail.contractPriceIndexAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractPriceIndexAmount
                          ? detail.contractPriceIndexAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.contractPriceIndexAmount
                        ? detail.contractPriceIndexAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 6 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>6</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>审计金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.auditAmount
                          ? detail.auditAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.auditAmount
                          ? detail.auditAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.auditAmount ? detail.auditAmount.actTaxAmount : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.auditAmount
                          ? detail.auditAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{ detail.auditAmount ? detail.auditAmount.remark : "" }}
                  </div>
                </td>
              </tr>
              <!-- 7 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>7</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同总收入金额</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractTotalIncomeAmount
                          ? detail.contractTotalIncomeAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractTotalIncomeAmount
                          ? detail.contractTotalIncomeAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractTotalIncomeAmount
                          ? detail.contractTotalIncomeAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.contractTotalIncomeAmount
                          ? detail.contractTotalIncomeAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.contractTotalIncomeAmount
                        ? detail.contractTotalIncomeAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 8 -->
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="5"
                >
                  <div>8</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="5"
                >
                  <div>直接成本</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>劳务费</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.serviceAmount
                          ? detail.serviceAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.serviceAmount
                          ? detail.serviceAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.serviceAmount
                          ? detail.serviceAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.serviceAmount
                          ? detail.serviceAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.serviceAmount
                          ? detail.serviceAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.serviceAmount ? detail.serviceAmount.remark : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>材料费</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.materialAmount
                          ? detail.materialAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.materialAmount
                          ? detail.materialAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.materialAmount
                          ? detail.materialAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.materialAmount
                          ? detail.materialAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.materialAmount
                          ? detail.materialAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.materialAmount ? detail.materialAmount.remark : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>机械使用费</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.machineAmount
                          ? detail.machineAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.machineAmount
                          ? detail.machineAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.machineAmount
                          ? detail.machineAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.machineAmount
                          ? detail.machineAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.machineAmount
                          ? detail.machineAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.machineAmount ? detail.machineAmount.remark : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>其他直接费</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherDirectAmount
                          ? detail.otherDirectAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherDirectAmount
                          ? detail.otherDirectAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherDirectAmount
                          ? detail.otherDirectAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherDirectAmount
                          ? detail.otherDirectAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherDirectAmount
                          ? detail.otherDirectAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.otherDirectAmount
                        ? detail.otherDirectAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>小计</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoDirectTotal
                          ? detail.tableTwoDirectTotal.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoDirectTotal
                          ? detail.tableTwoDirectTotal.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoDirectTotal
                          ? detail.tableTwoDirectTotal.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoDirectTotal
                          ? detail.tableTwoDirectTotal.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoDirectTotal
                          ? detail.tableTwoDirectTotal.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.tableTwoDirectTotal
                        ? detail.tableTwoDirectTotal.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 9 -->
              <tr style="border-bottom: 1px solid black">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>9</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  rowspan="3"
                >
                  <div>间接成本</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>管理费用</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectManagementAmount
                          ? detail.projectManagementAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectManagementAmount
                          ? detail.projectManagementAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectManagementAmount
                          ? detail.projectManagementAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectManagementAmount
                          ? detail.projectManagementAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.projectManagementAmount
                          ? detail.projectManagementAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.projectManagementAmount
                        ? detail.projectManagementAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>其他</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherIndirectAmount
                          ? detail.otherIndirectAmount.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherIndirectAmount
                          ? detail.otherIndirectAmount.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherIndirectAmount
                          ? detail.otherIndirectAmount.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherIndirectAmount
                          ? detail.otherIndirectAmount.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.otherIndirectAmount
                          ? detail.otherIndirectAmount.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.otherIndirectAmount
                        ? detail.otherIndirectAmount.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>小计</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoInDirectTotal
                          ? detail.tableTwoInDirectTotal.contractAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoInDirectTotal
                          ? detail.tableTwoInDirectTotal.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoInDirectTotal
                          ? detail.tableTwoInDirectTotal.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoInDirectTotal
                          ? detail.tableTwoInDirectTotal.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoInDirectTotal
                          ? detail.tableTwoInDirectTotal.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.tableTwoInDirectTotal
                        ? detail.tableTwoInDirectTotal.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 10 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>10</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同总成本合计</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoAllCostTotal
                          ? detail.tableTwoAllCostTotal.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoAllCostTotal
                          ? detail.tableTwoAllCostTotal.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoAllCostTotal
                          ? detail.tableTwoAllCostTotal.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoAllCostTotal
                          ? detail.tableTwoAllCostTotal.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.tableTwoAllCostTotal
                        ? detail.tableTwoAllCostTotal.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 11 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>11</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同毛利</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoGrossProfit
                          ? detail.tableTwoGrossProfit.budgetTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoGrossProfit
                          ? detail.tableTwoGrossProfit.budgetNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoGrossProfit
                          ? detail.tableTwoGrossProfit.actTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatMoneyNumber(
                        detail.tableTwoGrossProfit
                          ? detail.tableTwoGrossProfit.actNoTaxAmount
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      detail.tableTwoGrossProfit
                        ? detail.tableTwoGrossProfit.remark
                        : ""
                    }}
                  </div>
                </td>
              </tr>
              <!-- 12 -->
              <tr style="border-bottom: 1px solid black">
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>12</div>
                </td>
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  colspan="2"
                >
                  <div>合同毛利率</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatPercentNumber(
                        detail.tableTwoGrossMarginList
                          ? detail.tableTwoGrossMarginList[0]
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatPercentNumber(
                        detail.tableTwoGrossMarginList
                          ? detail.tableTwoGrossMarginList[1]
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatPercentNumber(
                        detail.tableTwoGrossMarginList
                          ? detail.tableTwoGrossMarginList[2]
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>
                    {{
                      formatPercentNumber(
                        detail.tableTwoGrossMarginList
                          ? detail.tableTwoGrossMarginList[3]
                          : 0
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div></div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-footer">
            <p>项目经理：</p>
            <p style="margin-right: 100px">制表人：</p>
          </div>
          <div>
            <h2>审批信息</h2>
            <div>
              <table
                style="
                  width: 100%;
                  border: 1px solid black;
                  table-layout: fixed;
                  border-collapse: collapse;
                "
              >
                <thead>
                  <tr style="text-align: left; border-bottom: 1px solid black">
                    <th style="border-right: 1px solid black">
                      <div style="padding: 12px 4px">序号</div>
                    </th>
                    <th style="border-right: 1px solid black">
                      <div style="padding: 12px 4px">员工名称</div>
                    </th>
                    <th style="border-right: 1px solid black">
                      <div style="padding: 12px 4px">岗位名称</div>
                    </th>
                    <th style="border-right: 1px solid black">
                      <div style="padding: 12px 4px">相关意见</div>
                    </th>
                    <th>
                      <div style="padding: 12px 4px">当前状态</div>
                    </th>
                    <th>
                      <div style="padding: 12px 4px">时间</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="approveData && approveData.length > 0">
                    <tr
                      v-for="(item, index) in approveData"
                      :key="index"
                      style="border-bottom: 1px solid black"
                    >
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div>
                          {{ index + 1 }}
                        </div>
                      </td>

                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div>
                          {{ item.approveUserName }}
                        </div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div>
                          {{ item.jobName }}
                        </div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div>
                          {{ item.opinion }}
                        </div>
                      </td>
                      <td style="padding: 12px 4px">
                        <div>
                          {{ item.statusName }}
                        </div>
                      </td>
                      <td style="padding: 12px 4px">
                        <div>
                          {{ item.updateTime }}
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr style="border-bottom: 1px solid black">
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                      <td
                        style="padding: 12px 4px; border-right: 1px solid black"
                      >
                        <div></div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 16px; text-align: center">
        <el-button type="primary" @click="printHandler">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatMoney, formatPercent } from "./utils";
import { formatEarningCostDetailTableData } from "./EarningHelper";
import { queryApproveHistoryApi } from "../../services/financeService";
import Constants from "../../utils/consts";
import printJS from "print-js";
/**
 * 收入成本管理-查看收入记录-收支明细表
 */
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    id: {
      type: [String, Number],
      default: "",
    },
    approveStatus: {
      type: [String, Number],
      default: "",
    },
    closefn: {
      type: Function
    }
  },
  computed: {
    tableData: function () {
      return formatEarningCostDetailTableData(this.detail);
    },
  },
  data() {
    return {
      previewBtnLoading: false,
      dialogVisible: false,
      approveData: [],
    };
  },
  methods: {
    formatDisplayNumber(rowData, key) {
      if (rowData.isPct) {
        return formatPercent(rowData[key]);
      }
      return formatMoney(rowData[key]);
    },
    spanArrayMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: row.span1.rowspan,
          colspan: 1,
        };
      }

      if (columnIndex == 1) {
        return {
          rowspan: row.span1.rowspan,
          colspan: row.span1.colspan,
        };
      }
      if (columnIndex == 2) {
        return {
          rowspan: row.span2.rowspan,
          colspan: row.span2.colspan,
        };
      }
    },
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    exportData() {
      //:导出收支明细表
      this.$emit("export-click", 3);
    },
    closePage() {
      if(this.closefn) {
        this.closefn()
        return
      }
      this.bus.$emit("tabClose", "incomingConstDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList",
      });
    },
    previewHandler() {
      this.previewBtnLoading = true;

      console.log("--detail", this.detail);

      queryApproveHistoryApi({
        approveClass: "EARNING_COST",
        itemId: this.id,
      })
        .then((res) => {
          console.log("----回报", res);
          if (res.code == Constants.Code_OK) {
            this.approveData = res.data || [];
            setTimeout(() => {
              this.dialogVisible = true;
            }, 0);
          } else {
            this.previewBtnLoading = false;
          }
        })
        .catch((error) => {
          console.log("----error", error);
          this.previewBtnLoading = false;
        });
    },
    printHandler() {
      printJS({
        printable: "earningCostDetailTablePrint",
        type: "html",
        targetStyles: ["*"],
        ignoreElements: ["no-print", "bc", "gb"],
        scanStyles: false,
      });
    },
    dialogClosed() {
      this.previewBtnLoading = false;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 16px;
  box-sizing: border-box;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.page-bottom-control {
  text-align: center;
  padding: 20px 0;
}
</style>
